<template>
  <v-container>
    <v-row
      v-if="formMode === 'changed'"
      class="mx-auto"
    >
      <v-col cols="12">
        {{ successMessage }}
      </v-col>
      <v-col cols="12">
        <v-btn
          v-if="!deleteInit"
          color="secondary"
          text
          @click="resetForm"
        >
          Reset
        </v-btn>
        <v-btn
          color="success"
          text
          @click="doCloseForm"
        >
          Close
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-else-if="formMode === 'edit'"
    >
      <v-col>
        <v-form
          class="mx-2"
        >
          <v-row>
            <v-select
              v-model="currentObject.plan_id"
              :items="filteredPlans"
              item-text="display_text"
              item-value="Id"
              label="Plan"
            >
              <template v-slot:label>
                <span class="frm-textbox mb-1">Plan</span>
              </template>
            </v-select>
          </v-row>
          <v-row>
            <v-select
              v-model="currentObject.cr_frequency"
              :items="optsBillingFreq"
            >
              <template v-slot:label>
                <span class="frm-textbox mb-1">Billing Frequency</span>
              </template>
            </v-select>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="currentObject.nextbill_short"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template v-slot:label>
                      <span class="frm-textbox mb-1">Next Billing Date</span>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="currentObject.nextbill_short"
                  no-title
                  scrollable
                  @input="menu = false"
                >
                </v-date-picker>
              </v-menu>

            </v-col>
            <v-col cols="4">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Presets
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    Text
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="mt-n2">
            <v-checkbox v-model="currentObject.closeout">
              <template v-slot:label>
                <div>
                  <span class="frm-checkbox">Generate a closeout invoice?</span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        class="ml-3"
                        color="info"
                        v-on="on"
                      >
                        mdi-help-circle
                      </v-icon>
                    </template>
                    Generate a closeout invoice for the existing plan before changes are applied.
                  </v-tooltip>
                </div>
              </template>
            </v-checkbox>
          </v-row>
          <v-alert
            v-if="formErrors.length > 0"
            type="error"
          >
            <v-list
              color="error"
            >
              <v-list-item
                v-for="(error, i) in formErrors"
                :key="`error-${i}`"
              >
                {{ error }}
              </v-list-item>

            </v-list>
          </v-alert>
          <v-alert
            v-if="changeInit"
            color="warning"
          >
            Please confirm changes
          </v-alert>
          <v-alert
            v-if="deleteInit"
            color="warning"
          >
            Please confirm you want to remove the rate and your closeout decision
          </v-alert>
          <v-row class="mt-2">
            <v-btn
              v-if="!deleteInit"
              color="error"
              @click="doInitRemovePlan"
            >
              <v-icon class="mr-1">
                mdi-trash-can-outline
              </v-icon>
              Remove
            </v-btn>
            <v-btn
              v-if="deleteInit"
              color="error"
              @click="doRemovePlan"
            >
              <v-icon class="mr-1">
                mdi-trash-can-outline
              </v-icon>
              Confirm Remove
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="warning"
              @click="doCloseForm"
            >
              Cancel
            </v-btn>
            <v-btn
              v-if="!changeInit"
              text
              color="success"
              @click="doInitChangePlan"
            >
              Submit
            </v-btn>
            <v-btn
              v-if="changeInit"
              text
              color="success"
              @click="doChangePlan"
            >
              Confirm
            </v-btn>
          </v-row>
          <v-overlay :value="overlayDisplay">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import basicMixin from '../../mixins/basic'
  import {
    _COMMIT_LOG,
    ACCT_ASSIGN_PLAN,
    ACCT_CHANGE_PLAN,
    ACCT_GET_ACCOUNT_RATES,
    PLAN_GET_PLANS,
    ACCT_REMOVE_PLAN,
    ACCT_GET_ACCOUNT_INVOICES,
  } from '../../store/actions.types'

  export default {
    // events
    // formClosed
    name: 'AccountAddPlan',

    mixins: [basicMixin],

    props: {
      item: {
        type: Object,
        default: () => ({
          crid: null,
          rgid: null,
        }),
      },
    },
    data: () => ({
      baseObject: {
        plan_id: null,
        frequency: null,
        quantity: 1,
        date: '',
        closeout: false,
      },
      currentObject: {
      },
      snapshotObject: {
      },
      menu: false,
      formMode: 'edit',
      formErrors: [],
      overlayAbsolute: true,
      overlayDisplay: false,
      changeInit: false,
      deleteInit: false,
      planChanged: false,
      successMessage: '',
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'profile', 'apTypes', 'apStatuses', 'towers', 'optsBillingFreq', 'acctSelectedAccount']),
      ...mapGetters('planModule', {
        allPlans: 'list',
        findPlan: 'find',
      }),
      filteredPlans: function () {
        return this.allPlans.filter((plan) => {
          return ((plan.fk_store_key === this.acctSelectedAccount.fk_store_key) || plan.Id === this.currentObject.plan_id)
        })
      },
      selectedPlan: function () {
        return this.findPlan(this.currentObject.plan_id)
      },
    },
    watch: {
      item: {
        handler: function (val, oldVal) {
          console.log('itemhandler fired')
          if (val.crid !== this.currentObject.crid || !this.currentObject.crid) {
            console.log('itemhandler set currentObject')
            val.closeout = false
            this.formMode = 'edit'
            this.currentObject = { ...val }
            this.snapshotObject = { ...val }
          }
        },
        deep: true,
      },
    },
    mounted () {
      this.init()
    },
    created () {
      this.init()
    },
    methods: {
      ...mapActions({
        commitLog: _COMMIT_LOG,
        assignPlan: ACCT_ASSIGN_PLAN,
        changePlan: ACCT_CHANGE_PLAN,
        removePlan: ACCT_REMOVE_PLAN,
        getInvoices: ACCT_GET_ACCOUNT_INVOICES,
        getAccountRates: ACCT_GET_ACCOUNT_RATES,
      }),
      ...mapActions('planModule', {
        getPlans: PLAN_GET_PLANS,
      }),
      async init () {
        // await this.getPlans()
        this.commitLog({ message: 'Initializing editPlan component setting values!', item: this.item })
        if (this.item.crid !== this.currentObject.crid || !this.currentObject.crid) {
          console.log('itemhandler set currentObject')
          this.formMode = 'edit'
          this.currentObject = { ...this.item }
          this.currentObject.closeout = false
          this.snapshotObject = { ...this.item }
          this.snapshotObject.closeout = false
        }
        this.resetForm()
      },
      async doInitRemovePlan () {
        this.deleteInit = true
      },
      async doRemovePlan () {
        this.overlayDisplay = true
        const formValid = this.doVerifyForm()
        if (!formValid) {
          this.overlayDisplay = false
          return
        }
        try {
          const assignPayload = {
            account_key: this.acctSelectedAccount.rowkey,
            crid: this.currentObject.crid,
            closeout: this.currentObject.closeout,
          }
          const responseData = await this.removePlan(assignPayload)
          if (responseData.success) {
            this.successMessage = `CRID ${this.currentObject.crid} - '${this.selectedPlan.display_text}' has been removed.`
            this.formMode = 'changed'
            await this.getAccountRates()
            this.getInvoices()
          } else {
            this.formErrors.push(responseData.responseText)
          }
        } catch (e) {
          await this.commitLog({ message: 'caught exception removing plan', error: e, force: true })
          if ((!e.problems || e.problems.length === 0)) {
            this.formErrors.push('Unknown error processing change')
          } else {
            this.formErrors = e.problems
          }
        }
        this.overlayDisplay = false
      },

      async doInitChangePlan () {
        const formValid = this.doVerifyForm()
        this.changeInit = formValid
      },
      async doChangePlan () {
        this.overlayDisplay = true
        const formValid = this.doVerifyForm()
        if (!formValid) {
          this.overlayDisplay = false
          return
        }
        try {
          const assignPayload = {
            account_key: this.acctSelectedAccount.rowkey,
            crid: this.currentObject.crid,
            planId: this.currentObject.plan_id,
            frequency: this.currentObject.cr_frequency,
            closeout: this.currentObject.closeout,
            bill_date: this.currentObject.nextbill_short,
          }
          const responseData = await this.changePlan(assignPayload)
          if (responseData.success) {
            this.successMessage = `CRID ${this.currentObject.crid} - '${this.selectedPlan.display_text}' has been updated.`
            this.formMode = 'changed'
            this.getInvoices()
            await this.getAccountRates()
          } else {
            this.formErrors.push(responseData.responseText)
          }
        } catch (e) {
          await this.commitLog({ message: 'caught exception changing plan', error: e, force: true })
          if ((!e.problems || e.problems.length === 0)) {
            this.formErrors.push('Unknown error processing change')
          } else {
            this.formErrors = e.problems
          }
        }
        this.overlayDisplay = false
      },
      doVerifyForm () {
        this.formErrors = []
        if (!this.currentObject.plan_id) {
          this.formErrors.push('A plan must be selected')
        }
        if (!this.currentObject.cr_frequency) {
          this.formErrors.push('Billing frequency must be selected')
        }
        if (!this.currentObject.nextbill_short || this.currentObject.nextbill_short === '') {
          this.formErrors.push('Billing date must be selected')
        }
        return this.formErrors.length === 0
      },
      resetForm () {
        // const date = this.currentObject.date
        // this.currentObject = { ...this.baseObject }
        // this.currentObject.date = date
        this.formErrors = []
        this.overlayDisplay = false
        this.planChanged = false
        this.formMode = 'edit'
        this.changeInit = false
        this.deleteInit = false
        this.successMessage = ''
      },
      doCloseForm () {
        this.resetForm()
        this.$emit('closeForm')
      },
    },

  }
</script>
